export default "__VITE_ASSET__Hx4Xgtea__"